module.exports = __webpack_public_path__ + "static/forte_main_4-b77c04f21801cf8e3ae5c8b1119efd6e.png";